// This file can be replaced during build by using the `fileReplacements` array.
// `ng build` replaces `environment.ts` with `environment.staging.ts`.
// The list of file replacements can be found in `angular.json`.

export const environment = {
  production: true,
  baseUrl: 'https://backend-prey.dev.42-projects.com/api',
  imageUrl: 'https://backend-prey.dev.42-projects.com/uploads/',
  clockifyUrl: 'https://api.clockify.me/api/v1',
  telemetryDeck: {
    enabled: false,
    appId: '',
  },
  showTester: true,
};

/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/plugins/zone-error';  // Included with Angular CLI.
